import { validateChatMessage } from "./chatValidations";

// Clase para manejar validaciones en componentes de clase
export class ChatValidator {
  constructor() {
    this.currentValidation = {
      isValid: true,
      isBlocked: false,
      errorMessage: '',
      violations: []
    };
  }

  // Método para validar mensaje y obtener resultado
  validate(message) {
    const result = validateChatMessage(message);
    this.currentValidation = result;
    return result;
  }

  // Método para obtener el estado actual
  getValidation() {
    return this.currentValidation;
  }

  // Método para verificar si está bloqueado
  isBlocked() {
    return this.currentValidation.isBlocked;
  }

  // Método para obtener el mensaje de error
  getErrorMessage() {
    return this.currentValidation.errorMessage;
  }

  // Método para obtener las violaciones
  getViolations() {
    return this.currentValidation.violations;
  }

  // Método estático para validación rápida sin instancia
  static validateMessage(message) {
    return validateChatMessage(message);
  }
}